import parse from 'html-react-parser'

import cn from '@/utils/tailwind/cn'

type Props = {
  value: string
} & React.HTMLAttributes<HTMLDivElement>

export const DescriptionQuestionRenderTextEditor = ({
  className,
  value,
  ...props
}: Props) => (
  <div className={cn('tiptap tiptap-render', className)} {...props}>
    {parse(value)}
  </div>
)
